export const convertSecsInMs = (seconds: number) => {
  return seconds * 1000
}
